import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import theme from './theme'
import App from './App'
import { initBridge } from './lib/iframe-bridge'
import { startAutoResize } from './lib/auto-resize'
import { EmbedParamsProvider } from './lib/embed-params'

initBridge()
startAutoResize()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <EmbedParamsProvider>
        <App />
      </EmbedParamsProvider>
    </ThemeProvider>
  </StrictMode>,
)
